import ky from 'ky';
import { getSession } from './session';

export const api = ky.create({
  prefixUrl: import.meta.env.PUBLIC_API_URL || '',
  timeout: 30_000,
  retry: 0,
  hooks: {
    beforeRequest: [
      async (request) => {
        if (request.method !== 'POST') {
          return;
        }

        const s = getSession();
        const session = {
          SessionId: s?.SessionId ?? '',
          UserId: s?.UserId ?? '',
          LocId: s?.LocId ?? '',
          LspId: s?.LspId ?? '',
        };
        const text = await request.text();
        const body = text ? JSON.parse(text) : {};
        return new Request(request.url, {
          method: request.method,
          headers: request.headers,
          body: JSON.stringify({ ...session, ...body }),
        });
      },
    ],
  },
});

// ─── GraphQL ─────────────────────────────────

type GraphQLResponse<T> = {
  data: T;
  errors?: Array<{ message: string }>;
};

export async function graphql<T>(
  query: string,
  variables: Record<string, unknown> = {},
): Promise<T> {
  const res = await api
    .post('api/graphql', { json: { query, variables } })
    .json<GraphQLResponse<T>>();

  if (res.errors?.length) {
    throw new Error(res.errors.map((e) => e.message).join('; '));
  }

  return res.data;
}
